import { Archive } from 'lucide-react'
import { Link, useLocation } from 'react-router'
import { ObjectStorageSwitcher } from '@/components/layout/breadcrumbs/object-storage/object-storage-switcher'
import {
  BreadcrumbItem,
  BreadcrumbPage,
  BreadcrumbLink,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb'
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from '@/components/ui/tooltip'
import { useCompanyPath } from '@/lib/hooks'

const ObjectStorageIconBreadcrumbItem = () => {
  const { getCompanyPath } = useCompanyPath()
  return (
    <BreadcrumbItem>
      <Link to={getCompanyPath({ pathname: '/object-storage' })}>
        <Tooltip delayDuration={1000}>
          <BreadcrumbPage className="cursor-pointer p-2 flex items-center rounded-md text-muted-foreground hover:bg-muted hover:text-foreground">
            <TooltipTrigger>
              <BreadcrumbLink asChild>
                <div className="cursor-pointer">
                  <Archive className="size-3.5" />
                  <span className="sr-only">Object storage</span>
                </div>
              </BreadcrumbLink>
            </TooltipTrigger>
          </BreadcrumbPage>
          <TooltipContent sideOffset={8}>
            <span>Object storage</span>
          </TooltipContent>
        </Tooltip>
      </Link>
    </BreadcrumbItem>
  )
}

export const ObjectStorageBreadcrumbs = () => {
  const { pathname } = useLocation()

  return (
    <>
      {pathname === '/object-storage' ? (
        <BreadcrumbItem>
          <BreadcrumbPage className="flex items-center gap-2 px-2">
            <Archive className="size-3.5" />
            <span className="font-medium">Object storage</span>
          </BreadcrumbPage>
        </BreadcrumbItem>
      ) : null}
      {pathname === '/object-storage/create' ? (
        <>
          <ObjectStorageIconBreadcrumbItem />
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage className="px-2 font-medium">
              Create object storage
            </BreadcrumbPage>
          </BreadcrumbItem>
        </>
      ) : null}
      {pathname.startsWith('/object-storage/') &&
      pathname !== '/object-storage/create' ? (
        <>
          <ObjectStorageIconBreadcrumbItem />
          <BreadcrumbSeparator />
          <ObjectStorageSwitcher />
        </>
      ) : null}
    </>
  )
}
